<template>
    <div class="breadcrumb-container">
        <div v-for="(item, index) in store" :key="item.id">
            <div
                class="breadcrumb-item"
                :class="{ 'no-hover': index === store.length - 1 }"
                @click="index === store.length - 1 ? null : goTo(item.link)"
            >
                <i
                    class="fas fa-angle-right"
                    v-if="index !== 0"
                    :style="
                        index !== store.length - 1 ? null : 'color: #ef7b1d'
                    "
                ></i>
                <span
                    :style="
                        index !== store.length - 1 ? null : 'color: #ef7b1d'
                    "
                    :class="item.name.length > 25 ? 'breadcrumb-span' : null"
                    >{{ item.name }}</span
                >
            </div>
        </div>
    </div>
</template>

<script>
import v1mixin from "@/mixins/v1.js"
export default {
    name: "ClassicBreadCrumb",
    async created() {
        await this.keepPath()
    },
    mixins: [v1mixin],
    watch: {
        routePath: {
            async handler(value) {
                if (this.routePath !== value) {
                    this.routePath = value
                    await this.keepPath()
                }
            },
        },
    },
    props: {
        title: {
            type: String,
            default: null,
        },
        options: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            store: [],
            routePath: this.$route.path,
            order: {
                Residences: 0,
                Residence: 1,
                Building: 2,
                Stairwell: 3,
                Apartment: 4,
            },
        }
    },
    methods: {
        async keepPath() {
            // Get a deep copy so as not modify the original directly
            this.store = await JSON.parse(
                JSON.stringify(
                    this.$store.getters["breadCrumb/getClassicBreadCrumb"],
                ),
            )

            // Get new route infos
            let newObject = {
                name: this.title,
                link: this.$route.path,
                routeName: this.$route.name,
                id: this.$route.params.id,
                options: this.options,
            }

            // Delete all of following elements if the current route is higher than them
            let alreadyInStoreIndex = false

            for (let i = 0; i < this.store.length; i++) {
                if (
                    this.store[i].routeName === newObject.routeName ||
                    (this.store[i].name === newObject.name &&
                        this.store[i].link === newObject.link)
                ) {
                    this.store.length = i
                    alreadyInStoreIndex = i
                }
            }
            if (typeof alreadyInStoreIndex === "number") {
                this.store[alreadyInStoreIndex] = newObject
            } else {
                this.store.push(newObject)
            }

            // Be sure to have the good order (cf. this.order). If object is not in the list, it will be added at the end.
            this.store.sort((a, b) => {
                return (
                    (this.order[a.routeName] ?? 99) -
                    (this.order[b.routeName] ?? 99)
                )
            })

            if (this.order[newObject.routeName] !== undefined) {
                const currentIndex = this.store.findIndex(
                    (item) =>
                        item.routeName === newObject.routeName &&
                        item.link === newObject.link,
                )
                if (currentIndex !== -1) {
                    this.store.length = currentIndex + 1
                }
            }

            // Save new version
            this.$store.commit("breadCrumb/setClassicBreadCrumb", this.store)
        },

        goTo(link) {
            if (link.startsWith("data")) {
                this.goToV1View(link)
            } else {
                this.$router.push(link)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_loader.scss";
@import "@/assets/scss/variables/fontSize.scss";

.breadcrumb-container {
    display: flex;
    flex-wrap: wrap;
    text-wrap: nowrap;
    align-items: center;
    gap: 0.5em;

    .breadcrumb-item {
        display: flex;
        align-items: center;
        gap: 0.5em;
        font-size: $normal;
        transition: 0.15s all;

        &:hover {
            cursor: pointer;
            color: $orange-neutral;
            transition: 0.15s all;
        }

        &::before {
            display: none;
        }
        @media all and (max-width: 834px) {
            & .breadcrumb-span {
                text-overflow: ellipsis;
                width: 25ch;
                overflow: hidden;
            }
        }
    }
}

.no-hover {
    cursor: default !important;
}
</style>
